// TanStack Query's defaults, chosen once — TODO T17 (30 Aug 2026).
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './core.ts';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        /**
         * Never retry a refusal. 401, 403, 404 and a bad cursor are all answers, not failures,
         * and retrying a `not_a_recruiter` three times per query turns one refused recruiter
         * into a burst of identical rejections in the BFF's log. Transient failures — the API
         * restarting, a dropped connection — are worth one retry and no more, because a poll is
         * along in a few seconds anyway.
         */
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 1;
        },
        // The screens poll on their own interval; refetching on every window focus as well would
        // double the request rate for no extra freshness.
        refetchOnWindowFocus: false,
      },
    },
  });
}
